import { get } from 'lodash';

export const isTestEnv = typeof process !== 'undefined' && get(process, 'env.NODE_ENV');
